<template>
    <div class="navbar-switcher">

        <div class="navbar-item navbar-switcher-trigger" @click="handleToggleActive">
            {{ label }}
            <BIcon icon="caret-down" style="margin-left: 5px; margin-right: 0; position: relative; top: -1px;"/>
        </div>

        <div class="navbar-switcher-container" :style="{
            left: position === 'is-left' ? 0 : 'auto',
            right: position === 'is-right' ? 0 : 'auto',
            width: `${width}px`,
        }" v-if="active"
             v-click-outside="handleClose">

            <div v-if="hasHeaderSlot" class="navbar-switcher-header">
                <div class="navbar-switcher-item is-active">
                    <slot name="header"></slot>
                </div>
            </div>

            <div class="navbar-switcher-items" :style="{ 'maxHeight': maxHeight + 'px' }">
                <slot></slot>
            </div>

            <div v-if="hasFooterSlot" class="navbar-switcher-footer">
                <div class="navbar-switcher-item">
                    <slot name="footer"></slot>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
export default {
  name: 'NavbarDropdownSwitcher',
  computed: {
    hasFooterSlot() {
      return !!this.$slots.footer;
    },
    hasHeaderSlot() {
      return !!this.$slots.header;
    }
  },
  data() {
    return {
      active: false,
    };
  },
  methods: {
    handleToggleActive() {
      this.active = !this.active;
    },
    handleClose() {
      this.active = false;
    },
  },
  props: {
    label: {
      default: '',
      type: String,
      required: true
    },
    maxHeight: {
      default: 250,
      type: Number
    },
    position: {
      default: 'is-left',
      type: String,
    },
    width: {
      default: 250,
      type: Number
    },
  },
};
</script>

<style lang="scss">
.navbar-switcher {
    align-items: center;
    display: flex;
    height: 100%;
    padding: 0 5px;
    position: relative;

    .navbar-switcher-trigger {
        align-items: center;
        display: flex;
        justify-content: flex-start;
        cursor: pointer;
        position: relative;

        .icon {
            position: relative;
            top: 2px;
        }

        .navbar-switcher-trigger-label {
            margin-right: 10px;
        }
    }

    .navbar-switcher-container {
        background: $black-bis;
        border: 1px solid $grey-darker;
        display: flex;
        flex-direction: column;
        max-height: 300px;
        min-width: 250px;
        overflow: hidden;
        position: absolute;
        top: 100%;
        z-index: 1;

        @include until($desktop) {
            border: none;
            bottom: 0;
            left: 0;
            max-height: none;
            min-height: auto;
            min-width: auto;
            position: fixed;
            right: 0;
            top: 55px;

            &::-webkit-scrollbar {
                width: 0;
                background: transparent;
            }
        }
    }

    .navbar-switcher-header {

        border-bottom: 1px solid $grey-darker;

        .navbar-switcher-item {
            border-left: 3px solid transparent;
            cursor: pointer;
            padding: 10px 15px;

            &:hover {
                background: $darkBlue;
            }

            &.is-active {
                border-left: 3px solid $primary;
            }
        }
    }

    .navbar-switcher-footer {

        border-top: 1px solid $grey-darker;

        .navbar-switcher-item {
            border-left: 3px solid transparent;
            cursor: pointer;
            padding: 10px 15px;

            &:hover {
                background: $darkBlue;
            }
        }
    }

    .navbar-switcher-items {
        flex: 1;
        overflow-y: scroll;
        white-space: nowrap;

        &::-webkit-scrollbar {
            width: 0;
            background: transparent;
        }

        section {
            border-left: 3px solid transparent;
            cursor: pointer;
            padding: 10px 15px;

            &:hover {
                background: $darkBlue;
            }
        }

    }
}
</style>

